function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import React from 'react';
import { FormFeedback, FormGroup, FormText, Label, Input } from 'reactstrap';
import { fieldPropTypes, fieldMetaPropTypes } from 'redux-form';
import styled from 'styled-components';
export var Feedback = styled(FormFeedback).withConfig({
  displayName: "FormInput__Feedback",
  componentId: "sc-1ptanvd-0"
})(["display:block;font-size:12px;min-height:12px;line-height:12px;margin:5px;"]);
var defaultErrorMap = {
  'blank': 'This must not be blank',
  'not_confirmed': 'This field must match the password',
  'invalid': 'This is not a valid value',
  'invalid_login_token': 'This must be either your email address, or your Flight username consisting of lowercase letters, numbers and hyphens (-).',
  'invalid_username_format': 'Usernames can only use lowercase letters, numbers and hypens (-), and must not start with a hyphen.',
  'not_accepted': 'You must accept the terms and conditions to continue.',
  'password_too_weak': 'The password is not strong enough',
  'required': 'This field is required',
  'too_long': 'This is too long',
  'too_short': 'This is too short'
};

function formattedErrors(error, completeErrorMap) {
  if (error == null) {
    return null;
  } else if (Array.isArray(error)) {
    return error.map(function (e) {
      return completeErrorMap[e] || e;
    }).join(', ');
  } else {
    return completeErrorMap[error] || error;
  }
}

var FormInput = function FormInput(_ref) {
  var check = _ref.check,
      errorMap = _ref.errorMap,
      help = _ref.help,
      helpProps = _ref.helpProps,
      hideLabel = _ref.hideLabel,
      id = _ref.id,
      input = _ref.input,
      label = _ref.label,
      _ref$meta = _ref.meta,
      error = _ref$meta.error,
      touched = _ref$meta.touched,
      custom = _objectWithoutProperties(_ref, ["check", "errorMap", "help", "helpProps", "hideLabel", "id", "input", "label", "meta"]);

  var inputEl = /*#__PURE__*/React.createElement(Input, _extends({
    id: id,
    valid: touched ? !error : undefined
  }, input, custom));

  var completeErrorMap = _objectSpread({}, defaultErrorMap, {}, errorMap);

  var errors = formattedErrors(error, completeErrorMap);
  return /*#__PURE__*/React.createElement(FormGroup, null, check ? inputEl : null, /*#__PURE__*/React.createElement(Label, {
    check: check,
    "for": id,
    hidden: hideLabel
  }, label), ' ', help ? /*#__PURE__*/React.createElement(FormText, helpProps, help) : '', check ? null : inputEl, ' ', errors && touched ? /*#__PURE__*/React.createElement(Feedback, null, errors) : /*#__PURE__*/React.createElement(Feedback, null), ' ');
};

FormInput.defaultProps = {
  errorMap: {}
};
FormInput.Feedback = Feedback;
export default FormInput;